export const enrollmentForm = {
  title: "Solicitud de Preinscripción",
  subtitle: "Completa este formulario y nos pondremos en contacto contigo para iniciar el proceso de admisión",
  
  contactInfo: "Datos de Contacto",
  parentName: "Nombre completo del padre/madre/tutor",
  email: "Email",
  phone: "Teléfono",
  
  childrenInfo: "Información de los Niños",
  child: "Niño/a",
  addChild: "Añadir otro hijo/a",
  childName: "Nombre del niño/a",
  birthDate: "Fecha de nacimiento",
  currentSchool: "Centro educativo actual",
  currentSchoolPlaceholder: "Opcional",
  desiredLevel: "Nivel deseado",
  
  levels: {
    infantil: "Infantil (3-5 años)",
    primaryC1: "Primaria C1 (6-8 años)",
    primaryC2: "Primaria C2 (9-11 años)"
  },
  
  preferences: "Preferencias",
  preferredStartDate: "Fecha de inicio deseada",
  immediate: "Inmediato",
  howDidYouHear: "¿Cómo nos conociste?",
  
  sources: {
    web: "Página web",
    recommendation: "Recomendación",
    socialMedia: "Redes sociales",
    openHouse: "Jornada de puertas abiertas",
    other: "Otro"
  },
  
  servicesInterest: "Servicios de Interés",
  services: {
    transport: "Transporte escolar",
    earlyBirds: "Madrugadores (8:00-8:45h)",
    lunch: "Comedor"
  },
  
  comments: "Comentarios o consultas",
  commentsPlaceholder: "Cuéntanos cualquier información adicional que consideres relevante...",
  
  privacyPolicy: "He leído la información sobre protección de datos",
  
  submit: "Enviar Solicitud",
  submitting: "Enviando...",
  
  success: "¡Solicitud enviada correctamente! Te contactaremos pronto.",
  error: "Error al enviar la solicitud. Por favor, inténtalo de nuevo o contacta directamente con nosotros.",

  stepper: {
    steps: {
      contact: "Tus datos",
      children: "Tus hijos",
      preferences: "Preferencias",
      services: "Servicios",
      review: "Revisión",
    },
    next: "Continuar",
    previous: "Anterior",
    stepOf: "Paso {current} de {total}",
  },
};